import styled from '@emotion/styled'

import { h6 } from '~/theme/utils/typography'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
`

export const MenuButton = styled.button`
  color: ${({ theme }) => theme.colors.green[500]};
  cursor: pointer;
  transition: color 0.3s;

  ${props => h6({ ...props, fontWeight: 'medium' })};

  &:hover {
    color: ${({ theme }) => theme.colors.green[600]};
  }
`
